// extracted by mini-css-extract-plugin
module.exports = {"listcon":"UserList_listcon__24HD4","header":"UserList_header__2TLcT","backbutton":"UserList_backbutton__2iR3C","title":"UserList_title__1QdUT"};